export const setResetButtonPosition = (component) => {
  component.outputs.collider = component.root;
  component.root.position.x = 6.14;
  component.root.position.y = 1.11;
  component.root.position.z = -1.16;
  component.root.rotation.y = Math.PI / 2;
  component.root.scale.setScalar(0.0015);
};

export const setResetSwitchPosition = (component) => {
  component.outputs.collider = component.root;
  component.root.position.x = 6.11;
  component.root.position.y = 1.12;
  component.root.position.z = -1.04;
  component.root.rotation.y = Math.PI / 2;
  component.root.scale.setScalar(0.0002);
};
